export class User {
    id: number;
    pk: number;
    token: string;
    first_name: string;
    last_name: string;
    username: string;
    image: string;
    email: string;
    name: string;
    last_login: null;
    is_active: true;
    created_at: string;
    updated_at: string;
    email_confirmation_token: string;
    reset_key: string;
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/models/user.model.ts